'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _paths = require('ifeis-isomorphic/lib/redux/actions/accounts/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/schools/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/person/paths');

// Periods in milliseconds
var now = new Date().getTime();
var historyPeriodInMs = 34186698000; // 13 months
var recentPeriodInMs = 1209600000; // 2 weeks
var priorityPeriodInMs = 1000 * 60 * 60 * 24 * 3; // 3 days


exports.default = function (user) {
  return function (state) {

    // PARENT data

    var account = (0, _paths3.getPerson)(state, user.id);
    var payments = (0, _paths.getPaymentsForAccount)(state, user.id);
    var feiseanna = (0, _paths.getMyFeiseanna)(state, user.id).toJS();
    var paymentsDue = (0, _paths.getBalancesForAccount)(state, user.id);

    // All user's feiseanna (future and past)
    // Including the starred feiseanna
    // Here, we're interested is the last 13 months of history only
    var myFeiseanna = feiseanna.filter(function (f) {
      return f.feis.dt_end > now - historyPeriodInMs || Date.now() > f.feis.dt_start && Date.now() < f.feis.dt_end;
    });

    // Results
    // Past feiseanna with registrations
    var recentResults = feiseanna.filter(function (f) {
      return now > f.feis.dt_start && now < f.feis.dt_end && f.recentResults === true;
    }).sort(function (a, b) {
      return b.feis.dt_end - a.feis.dt_end;
    }).map(function (f) {
      return f.feis;
    });

    var pastFeisResults = feiseanna.filter(function (f) {
      return f.feis.dt_end < now && f.recentResults === true;
    }).sort(function (a, b) {
      return b.feis.dt_end - a.feis.dt_end;
    }).map(function (f) {
      return f.feis;
    }).slice(0, 4);

    var results = recentResults.concat(pastFeisResults);

    // Should the Results card be displayed on top?
    var hasLastFeisEndedRecently = false;
    var isInProgressAndEventsInResults = false;
    if (results && results.length) {
      hasLastFeisEndedRecently = now > results.some(function (r) {
        return r.status !== 'IN_PROG';
      });
      isInProgressAndEventsInResults = results.some(function (r) {
        return now > r.dt_start && now < r.dt_end;
      });
    }

    // Payments due
    // Here, we're only interested in feiseanna, which ended less than 2 weeks ago
    // We sort them by reg_end date - to display the soonest closing for registration feiseanna first
    var due = paymentsDue && paymentsDue.size && myFeiseanna.filter(function (f) {
      return f.feis.dt_end > now - recentPeriodInMs && paymentsDue.getIn([f.feis.id, 'balance']);
    }).sort(function (a, b) {
      return b.feis.dt_reg_end - a.feis.dt_reg_end;
    }).map(function (f) {
      return _extends({}, f, {
        balance: paymentsDue.get(f.feis.id).toJS()
      });
    });

    // Should the Payments Due card be displayed on top?
    var isNextFeisRegistrationEndsSoon = false;
    if (due && due.length) {
      // If late reg date exists, the priority period should start 3 days before late reg
      // If not - 6 days before reg ends
      var nextFeis = due[0];
      var priorityPeriodStarts = nextFeis.feis.dt_reg_late ? nextFeis.feis.dt_reg_late - priorityPeriodInMs : nextFeis.feis.dt_reg_end - priorityPeriodInMs * 2;
      isNextFeisRegistrationEndsSoon = now > priorityPeriodStarts && now < nextFeis.feis.dt_reg_end - priorityPeriodInMs;
    }

    // Active feis (for the Feis Day card)
    // Here we're interested only in feiseanna, which are not closed and user is registered for
    // We sort them based on the feis start date - to display the soonest feiseanna first
    var myUpcomingFeiseanna = myFeiseanna.filter(function (f) {
      return !f.feis.is_finalized && f.registered === 1 && f.feis.dt_start < now + priorityPeriodInMs && f.feis.dt_end > now;
    }).filter(function (f) {
      return !f.feis.is_finalized && f.registered === 1;
    }).sort(function (a, b) {
      return b.feis.dt_start - a.feis.dt_start;
    });

    // Bind PARENT data
    var data = {
      account: account.toJS(),
      payments: payments.toJS(),
      myFeiseanna: myFeiseanna,
      results: results,
      due: due,
      myUpcomingFeiseanna: myUpcomingFeiseanna,
      hasLastFeisEndedRecently: hasLastFeisEndedRecently,
      isInProgressAndEventsInResults: isInProgressAndEventsInResults,
      isNextFeisRegistrationEndsSoon: isNextFeisRegistrationEndsSoon
    };

    // TEACHER data
    // Check is user is a teacher and has association with any schools
    if (user.is_teacher && user.teacher_at && user.teacher_at.length) {

      // Students feiseanna
      // Here, we're interested in the future feiseanna
      var studentsFeiseanna = user.teacher_at.map(function (sid) {
        return {
          school: (0, _paths2.getSchool)(state, sid).toJS(),
          feiseanna: ((prepareSchoolFeiseanna(state, sid) || (0, _immutable.Map)()).get('registration') || (0, _immutable.List)()).map(function (fid) {
            return state.getIn(['feiseanna', 'one', fid]) || (0, _immutable.Map)();
          }).filter(function (f) {
            return f.get('dt_end') > now;
          }).map(function (z) {
            return getFeisStatus(z.toJS());
          }).toJS()
        };
      });

      // My Students Results
      // Here, we're interested in in-prog where at least one event is in results as well as past feiseanna, which were finalized
      var studentResults = user.teacher_at.map(function (sid) {
        return {
          school: (0, _paths2.getSchool)(state, sid).toJS(),
          feiseanna: ((prepareSchoolFeiseanna(state, sid) || (0, _immutable.Map)()).get('released') || (0, _immutable.List)()).map(function (fid) {
            return state.getIn(['feiseanna', 'one', fid]) || (0, _immutable.Map)();
          }).filter(function (f) {
            return f.get('dt_end') > now - historyPeriodInMs && f.get('is_public') == 1;
          }).sort(function (a, b) {
            return b.get('dt_end') - a.get('dt_end');
          }).toJS()
        };
      });

      var teacherSchools = studentResults.map(function (pair) {
        return {
          school: pair.school
        };
      });

      // Bind TEACHER data
      data.studentsFeiseanna = studentsFeiseanna;
      data.studentResults = studentResults;
      data.teacherSchools = teacherSchools;
    }

    return data;
  };
};

// Helpers

var prepareSchoolFeiseanna = function prepareSchoolFeiseanna(state, sid) {
  return (0, _paths2.getFeiseannaForSchool)(state, sid);
};

var getFeisStatus = function getFeisStatus(feis) {
  if (!!feis.is_finalized || now > feis.dt_end) {
    feis.status = {
      text: 'FINISHED',
      class: 'f-finished'
    };
  } else if (now < feis.dt_reg_start) {
    feis.status = {
      text: 'OPENING SOON',
      class: 'f-reg-not-started'
    };
  } else if (!feis.dt_reg_start || !feis.dt_reg_end) {
    feis.status = {
      text: 'REGISTRATION DATES ARE NOT FINALIZED',
      class: ''
    };
  } else if (now > feis.dt_reg_start && now < feis.dt_reg_end && (!feis.dt_reg_late || feis.dt_reg_late && now < feis.dt_reg_late)) {
    feis.status = {
      text: 'REGISTRATION OPEN',
      class: 'f-reg-open'
    };
  } else if (!!feis.dt_reg_late && now > feis.dt_reg_late && now < feis.dt_reg_end) {
    feis.status = {
      text: 'LATE REGISTRATION OPEN',
      class: 'f-late-reg-open'
    };
  } else if (now > feis.dt_reg_end && now < feis.dt_start) {
    feis.status = {
      text: 'REGISTRATION CLOSED',
      class: 'f-reg-closed'
    };
  } else if (now > feis.dt_start && now < feis.dt_end) {
    feis.status = {
      text: 'IN PROGRESS',
      class: 'f-in-progress'
    };
  }

  return feis;
};


//////////////////
// WEBPACK FOOTER
// ./routes/dashboard/mapStateToController.js
// module id = 524
// module chunks = 0